import { render, staticRenderFns } from "./InstaSearch.vue?vue&type=template&id=68fc7ab8&scoped=true&"
import script from "./InstaSearch.vue?vue&type=script&lang=js&"
export * from "./InstaSearch.vue?vue&type=script&lang=js&"
import style0 from "./InstaSearch.vue?vue&type=style&index=0&id=68fc7ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc7ab8",
  null
  
)

export default component.exports